// extracted by mini-css-extract-plugin
export var aiStarIcon = "_t7-2";
export var container = "_t7-4";
export var dismissButton = "_t7-3";
export var hasPaddingBottom = "_t7-6";
export var last = "_t7-e";
export var scrollbarThumb = "_t7-c";
export var scrollbarTrack = "_t7-b";
export var selected = "_t7-9";
export var spin = "_t7-1";
export var spinning = "_t7-0";
export var suggestionItem = "_t7-d";
export var suggestionsPanel = "_t7-5";
export var tonePill = "_t7-8";
export var tonesContainer = "_t7-7";
export var unselected = "_t7-a";